export const isLinux = typeof navigator !== "undefined" && /linux/i.test(navigator.userAgent);
export const isWindows10Or11 = typeof navigator !== "undefined" && /windows nt 10/i.test(navigator.userAgent);

export const isChrome = typeof navigator !== "undefined" && /chrome/i.test(navigator.userAgent);
export const isEdge = typeof navigator !== "undefined" && /edg/i.test(navigator.userAgent);
export const isFirefox = typeof navigator !== "undefined" && /firefox/i.test(navigator.userAgent);
